import React, { useEffect, useState } from 'react';
const INITIAL_COPIES = 985;
const TOTAL_COPIES = 1985;
const MIN_COPIES = 30;
const STORAGE_KEY = 'bttf_copies_available';
export const UrgencyBar = () => {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    if (typeof window === 'undefined') return INITIAL_COPIES;
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : INITIAL_COPIES;
  });
  useEffect(() => {
    // Listen for custom event from CopiesAvailableCounter
    const handleCopiesUpdate = (event: CustomEvent) => {
      setCopiesLeft(event.detail);
    };
    window.addEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
    // Listen for storage changes from other tabs
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        const newValue = parseInt(e.newValue, 10);
        setCopiesLeft(newValue);
      }
    };
    window.addEventListener('storage', handleStorageChange);
    // Check localStorage periodically as backup
    const interval = setInterval(() => {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const newValue = parseInt(stored, 10);
        if (newValue !== copiesLeft && newValue <= copiesLeft) {
          setCopiesLeft(newValue);
        }
      }
    }, 500);
    return () => {
      window.removeEventListener('copiesUpdated', handleCopiesUpdate as EventListener);
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [copiesLeft]);
  // Calculate progress percentage based on TOTAL_COPIES (1985)
  const progressPercentage = Math.max(0, Math.min(100, copiesLeft / TOTAL_COPIES * 100));
  // Determine gradient color based on percentage
  const getGradientColor = () => {
    if (progressPercentage >= 75) {
      return 'from-christmas-green to-christmas-gold';
    } else if (progressPercentage >= 50) {
      return 'from-christmas-gold to-orange-500';
    } else if (progressPercentage >= 25) {
      return 'from-orange-500 to-christmas-red';
    } else {
      return 'from-christmas-red to-red-700';
    }
  };
  return <div className="w-full bg-gradient-to-r from-christmas-red/40 via-christmas-green/40 to-christmas-red/40 border-t border-christmas-gold/20 py-2 px-4" data-id="element-434">
      <div className="container mx-auto flex items-center justify-between gap-4" data-id="element-435">
        <div className="flex items-center gap-2" data-id="element-436">
          <span className="text-xs md:text-sm text-christmas-gold font-medium" data-id="element-437">
            🎄 Christmas Special
          </span>
          <span className="hidden md:inline text-xs text-bttf-subtext" data-id="element-438">
            Limited holiday pricing
          </span>
        </div>
        <div className="flex items-center gap-3 flex-1 max-w-md" data-id="element-439">
          <div className="flex-1 h-1.5 bg-black/60 rounded-full overflow-hidden" data-id="element-440">
            <div className={`h-full bg-gradient-to-r ${getGradientColor()} transition-all duration-300 ease-linear shadow-christmas-glow`} style={{
            width: `${progressPercentage}%`
          }} data-id="element-441"></div>
          </div>
          <span className="text-xs md:text-sm text-christmas-gold font-bold tabular-nums whitespace-nowrap" data-id="element-442">
            🎁 {copiesLeft} Left
          </span>
        </div>
      </div>
    </div>;
};